import { Logger } from "lib/logger"
import React, { useMemo } from "react"
import { withErrorBoundary } from "react-error-boundary"
import type { VariantType } from "@shared/graphql.types"
import { showCandleSafety } from "utils/show-candle-safety"
import { PDPAccordionLayoutB } from "../PDPAccordionLayoutV2"

type Props = {
  variant: VariantType
}
type ItemType = {
  label: string
  id?: string
}

const TabbedContentComponent: React.FC<Props> = ({ variant }) => {
  const categoryName = variant?.categoryName
  const hasHighlights = !!variant?.highlights?.length
  const hasKeyIngredients = !!variant?.formula?.keyIngredients?.length
  const hasStandards = !!variant.standards
  const hasFootnotes = !!variant.footNotes?.length

  const hasHighlightSection =
    hasHighlights || hasKeyIngredients || hasStandards || hasFootnotes
  const isSize = variant?.type === "size"
  const hasLifestyleAsPrimaryCategory = categoryName === "Lifestyle"

  const ctSupplementSpecialCase =
    categoryName === "Beauty Supplements" && hasKeyIngredients

  const listItems: ItemType[] = useMemo(() => {
    const items: ItemType[] = [{ label: "About this product" }]

    if (hasHighlightSection) items.push({ label: "Highlights" })
    if (isSize && hasLifestyleAsPrimaryCategory)
      items.push(
        { label: "Size and fit", id: "sizeTab" },
        { label: "Details and care", id: "sizeTab" }
      )

    if (!!variant.keyBenefits?.length || ctSupplementSpecialCase)
      items.push({ label: "Key benefit by ingredient" })

    if (variant?.formula?.ingredients?.length)
      items.push({ label: "Full ingredients list" })

    if (variant?.recommendedFor?.length)
      items.push({ label: "Recommended for" })

    if (variant?.cListRecommended)
      items.push({ label: "The C-List recommended product" })

    if (showCandleSafety(variant)) items.push({ label: "Candle safety" })

    return items
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variant])

  return (
    <PDPAccordionLayoutB
      listItems={listItems}
      marginTop={3}
      variant={variant}
    />
  )
}

export const TabbedContentV2 = withErrorBoundary(TabbedContentComponent, {
  fallback: <div />,
  onError(error) {
    Logger.warn(`TabbedContentB failed to load. ${error}`)
  },
})
